import MetaDataWrapper from '../containers/MetaDataWrapper';
import GooglePublisherTag from '../containers/GooglePublisherTag';
import { bannerAd } from '../components/GptProperties';
import AdvertWrapper from '../components/AdvertWrapper';
import React from 'react';
import PropTypes from 'prop-types';

export function StandardPage(props) {
  const { sport, title, helmetProps } = props;

  return (
    <div className={`main-layout ${sport}-home-page`} >

      <MetaDataWrapper title={title} helmetProps={helmetProps}/>
      <div className="main-layout-banner" id="main-layout-banner">
        <GooglePublisherTag adUnitPath={bannerAd.adUnitPath} type={bannerAd.type} section={sport} />
      </div>
      <AdvertWrapper ocSlot={["footer"]} additionalProperties={{classname: "fresh8-banner", view: sport}} isFooter />

      {props.children}
    </div>
  )
}

StandardPage.propTypes = {
  sport: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  helmetProps: PropTypes.object
};



// WEBPACK FOOTER //
// ./modules/Common/pages/StandardPage.js